'use client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { type ReactNode } from 'react';
import dynamic from 'next/dynamic';

interface RecaptchaWrapperProps {
  children: ReactNode;
}

function RecaptchaContent({ children }: RecaptchaWrapperProps) {
  const recaptchaSiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;

  if (!recaptchaSiteKey) {
    return <>{children}</>;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaSiteKey}
      language="en"
      useRecaptchaNet={true}
      scriptProps={{
        async: true,
        defer: true,
      }}
      container={{
        parameters: {
          badge: 'bottomright',
        },
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}

const DynamicRecaptchaContent = dynamic(
  () => Promise.resolve(RecaptchaContent),
  {
    ssr: false,
  }
);

export default function RecaptchaWrapper({
  children,
}: RecaptchaWrapperProps): React.JSX.Element {
  return <DynamicRecaptchaContent>{children}</DynamicRecaptchaContent>;
}
